import { useSyncExternalStore } from "react";
import { createPortal } from "react-dom";
import { useTranslation } from "react-i18next";

// Freundlicher Hinweis, wenn cProxy eine Funktion in dieser Umgebung ablehnt (HTTP 403 der
// Modell-Policy, ../SL_cProxy/TASKS.md: Modell nicht fuer diese Umgebung freigegeben). Kuenftig der
// Normalfall fuer gesperrte Profile - deshalb ein erklaerender Dialog statt eines roten Fehlers.
// Leichter externer Store (gleiches Muster wie ChangelogDialog), damit auch Hooks/Utils ohne
// Component-Kontext ihn ausloesen koennen.
let open = false;
const listeners = new Set<() => void>();
const emit = () => listeners.forEach(listener => listener());
const subscribe = (listener: () => void) => {
    listeners.add(listener);
    return () => { listeners.delete(listener); };
};

export const isModelUnavailableStatus = (status: number | undefined | null) => status === 403;

export const notifyModelUnavailable = () => {
    open = true;
    emit();
};

const close = () => {
    open = false;
    emit();
};

// In PageMasterTemplate gemountet.
export const ModelUnavailableHost = () => {
    const { t } = useTranslation('common');
    const isOpen = useSyncExternalStore(subscribe, () => open);
    if (!isOpen) return null;

    return createPortal(
        <div
            className="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
            style={{ backgroundColor: "rgba(0,0,0,0.5)", zIndex: 999999 }}
            onClick={close}
        >
            <div
                className="sengi-dialog p-4 text-body"
                style={{ maxWidth: 420, width: '90%' }}
                onClick={e => e.stopPropagation()}
                role="alertdialog"
                aria-labelledby="model-unavailable-title"
            >
                <h5 id="model-unavailable-title">{t('modelUnavailable.title')}</h5>
                <p className="text-secondary mb-4">{t('modelUnavailable.body')}</p>
                <div className="d-flex justify-content-end">
                    <button type="button" className="btn btn-primary" onClick={close}>
                        {t('actions.close')}
                    </button>
                </div>
            </div>
        </div>,
        document.body
    );
};
